import React from 'react';

const ForecastResultsPage = () => {
  return <div>예상 실적</div>;
};

export default ForecastResultsPage;
